import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Sirve si mi gato es viejo?',
    answer: 'Sí, el instinto territorial no tiene edad.'
  }, {
    question: '¿Tengo que comprar productos caros?',
    answer: 'No, te enseñamos qué buscar en la góndola y qué evitar.'
  }, {
    question: '¿Es seguro para mis hijos?',
    answer: 'Totalmente, usamos técnicas no invasivas.'
  }, {
    question: '¿Funciona con varios gatos?',
    answer: 'El protocolo está diseñado para frenar los conflictos entre ellos.'
  }];
  return <section className="w-full bg-[#FAFAF7] py-16 md:py-20 px-6" data-id="element-13">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-14">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-12 text-center" data-id="element-15">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-16">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} className="bg-white rounded-lg overflow-hidden shadow-sm" data-id="element-17">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-[#E8F0E8]/30 transition-colors" data-id="element-18">
                <span className="font-['Playfair_Display'] text-xl font-semibold text-[#1C1C1C] pr-4" data-id="element-19">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#2D8C5A] flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-20" />
              </button>
              <AnimatePresence data-id="element-21">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-22">
                    <div className="px-6 pb-6 text-[#1C1C1C]/80 leading-relaxed" data-id="element-23">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}